/**
 * 1セッションの往復数。
 * 原価は往復数の二乗で効く（往復ごとに全文脈が再課金されるため）。
 * 10往復20.6円 / 8往復14.3円、損益分岐転換率は 6.1% / 3.7%。
 * 安易に増やさないこと。
 */
export const MAX_TURNS = 8;

/**
 * この往復数以上進んだセッションのみ、無料枠を1回消費する。
 * 常に消費だと電波切れで不当に失う。消費しないとリロードで無限に使える。
 * 3が正しいかは実データを見るまで未確定なので、設定値として扱うこと。
 */
export const FREE_QUOTA_TURN_THRESHOLD = 3;

/** 無料体験の総回数（匿名1回 + 登録後2回） */
export const FREE_SESSION_LIMIT = 3;

/** 匿名のまま放置されたユーザー行を削除するまでの日数 */
export const ANON_RETENTION_DAYS = 30;

/** 応答が来ないまま経過したらターンを打ち切る（9往復中1回の無応答を観測） */
export const RESPONSE_TIMEOUT_MS = 8000;

/** これ以上離脱したら、中断されたAI発話を破棄して仕切り直す */
export const DISCARD_AFTER_MS = 30_000;

/**
 * これだけ無操作が続いたセッションを DO が abandoned として自動クローズする。
 * プッシュトゥトークの学習者は言葉に詰まって黙るため、短すぎると考え中に打ち切る。
 * 5分あれば「詰まって黙っている」ではなく「離脱した」と判断してよい。
 */
export const SESSION_IDLE_TIMEOUT_MS = 5 * 60 * 1000;

/** Gemini Live の音声レート */
export const INPUT_SAMPLE_RATE = 16000;
export const OUTPUT_SAMPLE_RATE = 24000;

/** 匿名で最初に体験させる固定シナリオ */
export const ONBOARDING_SCENARIO_ID = "kitchen-monday";
